import { generateMeta } from '@forge42/seo-tools/remix/metadata'
import { type Route } from './+types/tos.ts'

export const meta: Route.MetaFunction = () => {
	// This utility will under the hood generate the twitter & og title and description tags for you.
	const meta = generateMeta(
		{
			title: 'Terms of Service - DFW Professionals',
			description:
				'Read the Terms of Service for DFW Professionals, including data usage, security, availability, refunds, and contact information.',
			url: 'https://dfwprofessionals.com/tos',
		},
		[],
	)
	return meta
}

export default function TermsOfServicePage() {
	return (
		<>
			<div className="relative py-6">
				<div className="relative container mx-auto max-w-3xl pt-16 pb-12">
					<h1 className="mb-8 text-4xl font-bold tracking-tight sm:text-5xl">
						Terms of Service
					</h1>

					<div className="mx-auto mt-10 space-y-8">
						<section aria-labelledby="acceptance-of-terms">
							<h2 id="acceptance-of-terms" className="text-2xl font-semibold">
								1. Acceptance of Terms
							</h2>
							<p className="mt-4">
								By accessing and using DFW Professionals, you accept and agree to be
								bound by the terms and provision of this agreement.
							</p>
						</section>

						<section aria-labelledby="data-usage">
							<h2 id="data-usage" className="text-2xl font-semibold">
								2. Data Usage
							</h2>
							<p className="mt-4">
								We only access your data to provide our dashboard and analytics
								services. We do not:
							</p>
							<ul className="list-disc space-y-2 pl-6">
								<li>
									Mine or analyze your data for any purpose other than providing
									our service
								</li>
								<li>Share your data with third parties</li>
								<li>Use your data for advertising or marketing purposes</li>
								<li>
									Store your data longer than necessary to provide our service
								</li>
							</ul>
						</section>

						<section aria-labelledby="data-security">
							<h2 id="data-security" className="text-2xl font-semibold">
								3. Data Security
							</h2>
							<p className="mt-4">
								We implement industry-standard security measures to protect your
								data:
							</p>
							<ul className="list-disc space-y-2 pl-6">
								<li>End-to-end encryption for data transmission</li>
								<li>Secure data storage with encryption at rest</li>
								<li>Regular security audits and updates</li>
								<li>Access controls and authentication</li>
							</ul>
						</section>

						<section aria-labelledby="availability">
							<h2 id="availability" className="text-2xl font-semibold">
								4. Service Availability
							</h2>
							<p className="mt-4">
								We strive to maintain high service availability but cannot
								guarantee uninterrupted access. We may perform maintenance or
								updates that temporarily affect service availability.
							</p>
						</section>

						<section aria-labelledby="termination">
							<h2 id="termination" className="text-2xl font-semibold">
								5. Termination
							</h2>
							<p className="mt-4">
								You may terminate your account at any time. Upon termination, we
								will delete your data from our systems within 30 days, except
								where we are required to retain it for legal or regulatory
								purposes.
							</p>
						</section>

						<section aria-labelledby="limitation-liability">
							<h2 id="limitation-liability" className="text-2xl font-semibold">
								6. Limitation of Liability
							</h2>
							<p className="mt-4">
								DFW Professionals is provided &quot;as is&quot; without warranties of any
								kind. We are not liable for any damages arising from the use of
								our service.
							</p>
						</section>

						<section aria-labelledby="refunds">
							<h2 id="refunds" className="text-2xl font-semibold">
								7. No Refunds
							</h2>
							<p className="mt-4">
								All fees and charges are non-refundable, except where required
								by applicable law. If you cancel, downgrade, or terminate your
								account, you will not receive a refund or credit for any partial
								billing periods or unused services.
							</p>
						</section>

						<section aria-labelledby="changes">
							<h2 id="changes" className="text-2xl font-semibold">
								8. Changes to Terms
							</h2>
							<p className="mt-4">
								We may update these terms from time to time. We will notify you
								of any material changes via email or through our service.
							</p>
						</section>

						<section aria-labelledby="contact">
							<h2 id="contact" className="text-2xl font-semibold">
								9. Contact Information
							</h2>
							<p className="mt-4">
								If you have any questions about these terms, please contact us
								at{' '}
								<a
									href="mailto:info@dfwprofessionals.com"
									className="underline"
								>
									info@dfwprofessionals.com
								</a>
								.
							</p>
						</section>
					</div>
				</div>
			</div>
		</>
	)
}
